import React, {Component} from 'react';
import { LanguageConsumer } from './lib/LanguageContext'
import { Link, NavLink, withRouter} from 'react-router-dom';
import './Header.css';


const appName = 'identify';

class Header extends Component {
    
   state = {
       mobileTooltipActive: false
   }

   toggleMobileTooltip = () => {
       this.setState(prevState => ({
          mobileTooltipActive: !prevState.mobileTooltipActive 
       }))
   }

   closeMobileTooltip = () => {
       this.setState({mobileTooltipActive: false})
   }

   setWrapperLinkRef = (node) => {
        this.wrapperLinkRef = node;
   }

   setWrapperTooltipRef = (node) => {
        this.wrapperTooltipRef = node;
   }

   componentDidMount = () => {
       document.addEventListener('mousedown', this.handleClickOutside)
   }

   componentWillUnmount = () => {
       document.removeEventListener('mousedown', this.handleClickOutside)
   }

   handleClickOutside = (e) => {
       if(this.wrapperLinkRef && this.state.mobileTooltipActive 
          && !this.wrapperLinkRef.contains(e.target) 
          && this.wrapperTooltipRef && !this.wrapperTooltipRef.contains(e.target)) {
           this.closeMobileTooltip()
       }
   }

   Delay = (e) => {
        e.preventDefault()
        setTimeout(() => {
            this.props.history.push('/login')
        },500)
        this.props.handleLogout();
   }

   mobileLogout = (e) => {
     this.closeMobileTooltip()
     this.Delay()
   }

    render() {
        const isLoggedIn = this.props.loggedIn;
        return(
          <LanguageConsumer>
            {({polyglot}) =>
               (<header className="App-header">
                   <span className="headerGroupLeft">
                       <NavLink exact to="/" className='banner'><h2>{appName}</h2></NavLink>
                   </span>
                   <span className="headerGroupRight">
                       {isLoggedIn && 
                           <NavLink exact to="/overview" className='header-item'>
                                   <span id='header-username'>
                                       <span className='fas fa-university' id='user-icon'></span> 
                                       <span> {this.props.institutionId.toUpperCase()}</span>
                                   </span>
                           </NavLink>
                       }
                       <NavLink exact to="/" className='header-item' activeClassName='active'>
                           {polyglot.t('landing')}
                       </NavLink>
                       {isLoggedIn ? (
                           <NavLink to="/logout" className='header-item' activeClassName='active' onClick={this.Delay}>
                               {polyglot.t('logout')}
                           </NavLink>
                       ) :
                       (
                           <NavLink to="/login" className='header-item' activeClassName='active'>
                               {polyglot.t('login')}
                           </NavLink>
                       )
                       }
                   </span>
                   <span className="headerGroupRight mobile">
                       <button ref={this.setWrapperLinkRef} className={`toggle-tooltip ${this.state.mobileTooltipActive ? 'active' : ''}`}
                               onClick={this.toggleMobileTooltip}>
                           <span className='fas fa-university'></span>
                       </button>
                       <div ref={this.setWrapperTooltipRef} className={`tooltip ${this.state.mobileTooltipActive ? 'active' : ''}`}
                            >
                           {isLoggedIn && 
                               <Link exact to="/overview" 
                                     className='header-item' 
                                     onClick={this.closeMobileTooltip}>
                                   <span id='header-username'>
                                       <span> {this.props.institutionId.toUpperCase()}</span>
                                   </span>
                               </Link>
                           }
                           <Link exact to="/" 
                                 className='header-item' 
                                 activeClassName='active' 
                                 onClick={this.closeMobileTooltip}>
                               {polyglot.t('landing')}
                           </Link>
                           {isLoggedIn ? (
                               <Link to="/logout" 
                                     className='header-item' 
                                     activeClassName='active'
                                     onClick={this.Delay}>
                                   {polyglot.t('logout')}
                               </Link>
                           ) :
                           (
                               <Link to="/login" className='header-item' activeClassName='active'>
                                   {polyglot.t('login')}
                               </Link>
                           )
                           }
                     </div>
                   </span>
                </header>)}
          </LanguageConsumer>
        )
    }
}

export default Header = withRouter(Header);



// WEBPACK FOOTER //
// ./src/Header.js